import React, { useId } from "react";
import { Backdrop, Button, CircularProgress, Grid } from "@material-ui/core";

import Tooltip from "@material-ui/core/Tooltip";
import PageTitle from "../../../components/PageTitle";
import useStyles from "../../../themes/style.js";
import { useState, useEffect } from "react";
import axios from "axios";
import {
  Box,
  Dialog,
  DialogTitle,
  DialogActions,
  DialogContent,
  FormControl,
  InputLabel,
  TextField,
  TextareaAutosize,
  TablePagination,
  Typography,
  Card,
  CardContent,
  CardHeader,
  Chip,
} from "@material-ui/core";
import {} from "@material-ui/core";
import { useForm, useFieldArray } from "react-hook-form";
import { Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import { IoAdd, IoRemove } from "react-icons/io5";
import Switch from "@material-ui/core/Switch";
import { useLocation } from "react-router-dom";
import { useNotification } from "../../../hooks/useNotification.js";
import { makeStyles } from "@material-ui/core/styles";
import { MdEdit } from "react-icons/md";
import moment from "moment";
import NoDataFound from "../../../components/NoDataFound/index.js";

const useCardStyles = makeStyles((theme) => ({
  card: {
    maxWidth: 400,
    margin: "auto",
    border: `1px solid ${theme.palette.divider}`,

    boxShadow: theme.shadows[3],
    borderRadius: theme.shape.borderRadius,
  },
  statusChip: {
    marginTop: theme.spacing(1),
    fontWeight: "bold",
    color: theme.palette.common.white,
  },
  reterned: {
    backgroundColor: theme.palette.success.main,
    borderTop: `3px solid ${theme.palette.success.dark}`,
  },
  inPossession: {
    backgroundColor: "#3f51b5",
  },
  root: {
    "& .Mui-disabled": {
      color: "#4caf50 !important", // Success green for disabled
    },
  },
  switchBase: {
    color: "#ff4081", // Thumb color when unchecked (pink)
    "&.Mui-checked": {
      color: "#4caf50", // Thumb color when checked (green)
    },
    "&.Mui-disabled + .MuiSwitch-track": {
      backgroundColor: "#4caf50 !important", // Track color when disabled
    },
  },
  track: {
    backgroundColor: "#bdbdbd", // Track color when unchecked (gray)
    "&.Mui-checked": {
      backgroundColor: "#4caf50", // Track color when checked (green)
    },
    "&.Mui-disabled": {
      backgroundColor: "#9e9e9e", // Track color when disabled (light gray)
    },
  },
}));

const AdminAssetManagent = () => {
  const classes = useStyles();
  const cardClasses = useCardStyles();

  const [loader, setLoader] = useState(false);
  const token = localStorage.getItem("token");

  const [assetsModalOpen, setAssetsModalOpen] = useState(false);
  const [assetsEditModalOpen, setAssetsEditModalOpen] = useState(false);

  const location = useLocation();

  const [count, setCount] = useState(0);

  const [assetsDetails, setAssetsDetails] = useState([]);

  const [editAssetDetails, setEditAssetDetails] = useState([]);

  const [page, setPage] = useState(0);

  const handleNotificationCall = useNotification();

  const queryParams = new URLSearchParams(location.search);

  const userID = queryParams.get("userId");
  console.log(userID);

  const handleAssetsModalOpen = () => {
    setAssetsModalOpen(true);
  };

  const handleAssetsModalClose = () => {
    setAssetsModalOpen(false);
  };

  const handleAssetsEditModalOpen = (item) => {
    setAssetsEditModalOpen(true);
    setEditAssetDetails(item);
    editSetValue("id", item.id);
    editSetValue("userId", item.userId);
    editSetValue("assetName", item.assetName);
    editSetValue("assetType", item.assetType);
    editSetValue("assetDescription", item.assetDescription);
    editSetValue("assetStatus", item.assetStatus);
  };

  console.log(editAssetDetails);

  const handleAssetsEditModalClose = () => {
    setAssetsEditModalOpen(false);
  };

  const validationSchema = Yup.object().shape({
    userAssests: Yup.array().of(
      Yup.object().shape({
        userId: Yup.string(),
        assetName: Yup.string().required("Asset Name is required"),
        assetType: Yup.string().required("Asset Type is required"),
        assetDescription: Yup.string().required(
          "Asset Description is required",
        ),
      }),
    ),
  });

  const editValidationSchema = Yup.object().shape({
    assetName: Yup.string().required("Asset Name is required"),
    assetType: Yup.string().required("Asset Type is required"),
    assetDescription: Yup.string().required("Asset Description is required"),
  });

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    setLoader(true);

    try {
      const viewAlldata = await axios.get(
        `${process.env.REACT_APP_SERVER}assets/viewUserAssets?userId=${userID}`,
        {
          headers: {
            Authorization: token,
            "Content-Type": "application/json",
          },
        },
      );
      if (viewAlldata.data.status) {
        setAssetsDetails(viewAlldata.data.data);
        setLoader(false);

        // setCount(viewAlldata.data.count);
      } else {
        handleNotificationCall("error", viewAlldata.data.message);
      }
    } catch (error) {
      console.log(error);
      handleNotificationCall("error", "Error Happend!");
    } finally {
      setLoader(false);
    }
  };

  async function handleAdd(values) {
    console.log("Data Added out Api");
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_SERVER}assets/addAssets`,
        {
          userAssests: values.userAssests,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: token,
          },
        },
      );
      setLoader(false);

      if (response.data.status === true) {
        handleNotificationCall("success", response.data.message);
        reset();
        handleAssetsModalClose();
        fetchData();
        console.log("Data Added in Api");
      } else {
        handleNotificationCall("error", response.data.message);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoader(false);
    }
  }

  async function handleEdit(values) {
    console.log(values);

    //   try {
    //     const data=values
    //     const response = await axios.post(
    //       `${process.env.REACT_APP_SERVER}assets/editAsset`,
    //       data,
    //       {
    //         headers: {
    //           "Content-Type": "application/json",
    //           Authorization:token,
    //         },
    //       },
    //     );
    //     setLoader(false);

    //     if (response.data.status === true) {
    //       handleNotificationCall("success", response.data.message);
    //       editReset();
    //       handleAssetsEditModalClose();
    //       fetchData();
    //     } else {
    //       handleNotificationCall("error", response.data.message);
    //     }
    //   } catch (error) {
    //     console.error(error);
    //   } finally {
    //     setLoader(false);

    // }
  }

  const handleStatusChange = async (e) => {
    console.log(e.target.checked);
    editSetValue("assetStatus", e.target.checked);
    setEditAssetDetails({
      ...editAssetDetails,
      assetStatus: !editAssetDetails.assetStatus,
    });

    try {
      const data = { id: editAssetDetails.id, userId: editAssetDetails.userId };
      const response = await axios.post(
        `${process.env.REACT_APP_SERVER}assets/returnAsset`,
        data,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: token,
          },
        },
      );
      setLoader(false);

      if (response.data.status === true) {
        handleNotificationCall("success", response.data.message);
        editReset();
        handleAssetsEditModalClose();
        fetchData();
      } else {
        handleNotificationCall("error", response.data.message);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoader(false);
    }
  };

  console.log(assetsDetails);

  const {
    register,
    handleSubmit,
    reset,
    setValue,
    control,
    formState: { errors, isSubmitting },
  } = useForm({
    resolver: yupResolver(validationSchema),
    defaultValues: {
      userAssests: [
        {
          userId: userID,
          assetName: "",
          assetType: "",
          assetDescription: "",
        },
      ],
    },
  });

  const {
    register: editRegister,
    handleSubmit: editHandleSubmit,
    reset: editReset,
    setValue: editSetValue,
    control: editConrol,
    formState: { errors: editErrors, isSubmitting: editIsSubmitting },
  } = useForm({
    resolver: yupResolver(editValidationSchema),
  });

  const { fields, append, remove } = useFieldArray({
    control: control,
    name: "userAssests",
  });

  const AssetCard = ({ assetsDetails }) => {
    return (
      <Card
        className={cardClasses.card}
        style={{
          borderTop: assetsDetails.assetStatus
            ? "3px solid #3f51b5"
            : "3px solid #10B981",
          height: "100%",
          position: "relative",
          marginBottom: "50px",
          paddingBottom: "30px",
        }}
      >
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <CardHeader
            title={assetsDetails.assetName}
            subheader={assetsDetails.assetType}
            titleTypographyProps={{
              variant: "h4",
              color: "primary",
              style: { fontSize: "20px", fontWeight: 600 },
            }}
            subheaderTypographyProps={{
              variant: "subtitle1",
              color: "textSecondary",
            }}
          />
          {assetsDetails.assetStatus && (
            <Tooltip
              title="Edit Asset Details"
              placement="bottom"
              aria-label="Edit"
            >
              <Button
                style={{
                  margin: "0 10px 5px 0",
                  borderRadius: "50%",
                  padding: "10px",
                  width: "max-content",
                  minWidth: "38px",
                }}
                onClick={() => handleAssetsEditModalOpen(assetsDetails)}
              >
                <MdEdit size={18} />
              </Button>
            </Tooltip>
          )}
        </Box>
        <CardContent>
          <Typography variant="body2" color="textSecondary">
            {assetsDetails.assetDescription}
          </Typography>

          <br />

          <div style={{ position: "absolute", bottom: "15px", left: "15px" }}>
            <Typography variant="body2" color="dark">
              <span style={{ color: "#3f51b5" }}>In Possession Date: </span>{" "}
              {`${moment(assetsDetails.givenTime).format("DD-MM-YYYY")}`}
              <br />
              {!assetsDetails.assetStatus && (
                <>
                  <span style={{ color: "#10B981" }}>Reterned Date:</span>{" "}
                  {moment(assetsDetails.returnedTiming).format("DD-MM-YYYY")}
                </>
              )}
            </Typography>

            <Chip
              label={assetsDetails.assetStatus ? "In Possession" : "Reterned"}
              className={`${cardClasses.statusChip}`}
              style={{
                backgroundColor: assetsDetails?.assetStatus
                  ? "#3f51b5"
                  : "#10B981",
              }}
            />
          </div>
        </CardContent>
      </Card>
    );
  };

  return (
    <>
      <Box display="flex" justifyContent="flex-end" mt={2}>
        <Button
          variant="contained"
          color="primary"
          size="small"
          onClick={handleAssetsModalOpen}
        >
          Add Assets Details
        </Button>
      </Box>

      {assetsDetails.length === 0 && <NoDataFound height="80vh" message="No Data Found"/>}
      <Grid container spacing={2} style={{ marginTop: 20 }}>
        {assetsDetails.map((item) => (
          <Grid item key={item._id} xs={12} sm={6} md={4} lg={3}>
            <AssetCard assetsDetails={item} />
          </Grid>
        ))}
      </Grid>

      {/* <Grid
              container
              spacing={2}
              className={classes.pagination}
              style={{ marginTop: "30px" }}
            >
              <TablePagination
                rowsPerPageOptions={[10]}
                component="div"
                count={count}
                rowsPerPage={10}
                page={page}
                onPageChange={handleChangePage}
              />
            </Grid> */}

      <Dialog
        open={assetsModalOpen}
        fullWidth
        maxWidth="md"
        onClose={handleAssetsModalClose}
        aria-labelledby="Add Assets Details"
      >
        <form onSubmit={handleSubmit(handleAdd)}>
          <h3
            style={{
              padding: "12px 12px",
              margin: "10px 10px 0",
              fontSize: "18px",
            }}
          >
            Add Assets Details
          </h3>
          {/* <DialogTitle style={{fontSize:"28px" ,margin:"20px"}}>Add Assets Details</DialogTitle> */}
          <DialogContent>
            <Grid container direction="row" spacing={2}>
              {fields.map((field, index) => (
                <React.Fragment key={field.id}>
                  <Grid item xs={12} md={6} lg={4}>
                    <InputLabel
                      shrink
                      htmlFor={`userAssests.${index}.assetName`}
                    >
                      Asset Name
                    </InputLabel>
                    <FormControl className={classes.margin}>
                      <TextField
                        size="small"
                        InputProps={{ disableUnderline: true }}
                        classes={{ root: classes.customTextField }}
                        placeholder="Enter the Asset Name"
                        name={`userAssests.${index}.assetName`}
                        {...register(`userAssests.${index}.assetName`)}
                        error={
                          errors.userAssests?.[index]?.assetName ? true : false
                        }
                      />

                      <Typography variant="inherit" color="error">
                        {errors.userAssests?.[index]?.assetName?.message}
                      </Typography>
                    </FormControl>
                  </Grid>

                  <Grid item xs={12} md={6} lg={3}>
                    <InputLabel
                      shrink
                      htmlFor={`userAssests.${index}.assetType`}
                    >
                      Asset Type
                    </InputLabel>
                    <FormControl className={classes.margin}>
                      <TextField
                        size="small"
                        InputProps={{ disableUnderline: true }}
                        classes={{ root: classes.customTextField }}
                        placeholder="Enter the Asset Type"
                        name={`userAssests.${index}.assetType`}
                        {...register(`userAssests.${index}.assetType`)}
                        error={
                          errors.userAssests?.[index]?.assetType ? true : false
                        }
                      />

                      <Typography variant="inherit" color="error">
                        {errors.userAssests?.[index]?.assetType?.message}
                      </Typography>
                    </FormControl>
                  </Grid>

                  <Grid item xs={12} md={6} lg={3}>
                    <InputLabel
                      shrink
                      htmlFor={`userAssests.${index}.assetDescription`}
                    >
                      Asset Description
                    </InputLabel>
                    <FormControl className={classes.margin}>
                      <TextareaAutosize
                        minRows={1}
                        style={{ marginTop: "7px", padding: "10px 6px" }}
                        size="small"
                        InputProps={{
                          disableUnderline: true,
                          style: { resize: "both" },
                        }}
                        classes={{ root: classes.customTextField }}
                        placeholder="Enter the Description"
                        name={`userAssests.${index}.assetDescription`}
                        {...register(`userAssests.${index}.assetDescription`)}
                        error={
                          errors.userAssests?.[index]?.assetDescription
                            ? true
                            : false
                        }
                        multiline
                        fullWidth
                      />

                      <Typography variant="inherit" color="error">
                        {errors.userAssests?.[index]?.assetDescription?.message}
                      </Typography>
                    </FormControl>
                  </Grid>

                  <div
                    style={{
                      display: "inline-flex",
                      gap: "5px",
                      alignItems: "end",
                      marginBottom: "9px",
                      fontSize: "16px",
                      fontWeight: "900",
                      color: "#374151",
                    }}
                  >
                    <Button
                      type="button"
                      onClick={() =>
                        append({
                          assetName: "",
                          assetType: "",
                          assetDescription: "",
                          userId: userID,
                        })
                      }
                    >
                      <IoAdd size={26} color="green" />
                    </Button>

                    {!index == 0 && (
                      <Button type="button" onClick={() => remove(index)}>
                        <IoRemove size={26} color="red" />
                      </Button>
                    )}
                  </div>
                </React.Fragment>
              ))}
            </Grid>
          </DialogContent>
          <DialogActions style={{ padding: "12px 24px" }}>
            <Button
              onClick={handleAssetsModalClose}
              variant="contained"
              color="secondary"
              size="small"
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              color="primary"
              size="small"
              type="submit"
            >
              Save
            </Button>
          </DialogActions>
        </form>
      </Dialog>

      <Dialog
        open={assetsEditModalOpen}
        fullWidth
        maxWidth="md"
        onClose={handleAssetsEditModalClose}
        aria-labelledby="Edit Assets Details"
      >
        <form onSubmit={editHandleSubmit(handleEdit)}>
          <h3
            style={{
              padding: "12px 12px",
              margin: "10px 10px 0",
              fontSize: "18px",
            }}
          >
            Edit Assets Details
          </h3>
          <DialogContent>
            <Grid container direction="row" spacing={2}>
              <React.Fragment>
                <Grid item xs={12} md={6} lg={3}>
                  <InputLabel shrink htmlFor="assetName">
                    Asset Name
                  </InputLabel>
                  <FormControl className={classes.margin}>
                    <TextField
                      size="small"
                      InputProps={{ disableUnderline: true }}
                      classes={{ root: classes.customTextField }}
                      placeholder="Enter the Asset Name"
                      name={"assetName"}
                      {...editRegister("assetName")}
                      defaultValue={editAssetDetails?.assetName}
                      error={editErrors.assetName ? true : false}
                    />

                    <Typography variant="inherit" color="error">
                      {editErrors.assetName?.message}
                    </Typography>
                  </FormControl>
                </Grid>

                <Grid item xs={12} md={6} lg={3}>
                  <InputLabel shrink htmlFor={"assetType"}>
                    Asset Type
                  </InputLabel>
                  <FormControl className={classes.margin}>
                    <TextField
                      size="small"
                      InputProps={{ disableUnderline: true }}
                      classes={{ root: classes.customTextField }}
                      placeholder="Enter the Asset Type"
                      name={"assetType"}
                      {...editRegister("assetType")}
                      defaultValue={editAssetDetails.assetType}
                      error={editErrors.assetType ? true : false}
                    />

                    <Typography variant="inherit" color="error">
                      {editErrors.assetType?.message}
                    </Typography>
                  </FormControl>
                </Grid>

                <Grid item xs={12} md={6} lg={3}>
                  <InputLabel shrink htmlFor={"assetDescription"}>
                    Asset Description
                  </InputLabel>
                  <FormControl className={classes.margin}>
                    <TextareaAutosize
                      minRows={1}
                      style={{ marginTop: "7px", padding: "10px 6px" }}
                      size="small"
                      InputProps={{ disableUnderline: true }}
                      classes={{ root: classes.customTextField }}
                      placeholder="Enter the Description"
                      name={"assetDescription"}
                      defaultValue={editAssetDetails.assetDescription}
                      {...editRegister("assetDescription")}
                      error={editErrors.assetDescription ? true : false}
                    />

                    <Typography variant="inherit" color="error">
                      {editErrors.assetDescription?.message}
                    </Typography>
                  </FormControl>
                </Grid>

                <Grid item xs={12} md={6} lg={3}>
                  <InputLabel shrink htmlFor={"assetStatus"}>
                    Asset Returned
                  </InputLabel>
                  <div className={cardClasses.root}>
                    <FormControl className={classes.margin}>
                      <Switch
                        classes={{
                          switchBase: cardClasses.switchBase,
                        }}
                        name={"assetStatus"}
                        {...editRegister("assetStatus")}
                        onChange={handleStatusChange}
                        checked={!editAssetDetails.assetStatus}
                        color="success"
                        disabled={!editAssetDetails.assetStatus}
                      />
                    </FormControl>
                  </div>
                </Grid>

                {/* <div
                    style={{
                      display: "inline-flex",
                      gap: "5px",
                      alignItems: "end",
                      marginBottom: "15px",
                      fontSize: "16px",
                      fontWeight: "900",
                      color: "#374151",
                    }}
                  >
                    <Button
                      type="button"
                      onClick={() =>
                        append({
                          assetName: "",
                          assetType: "",
                          assetDescription: "",
                          assetStatus: false,
                          userID: userID,
                        })
                      }
                    >
                      <IoAdd size={26} color="green" />
                    </Button>

                    {!index == 0 &&  <Button
                      type="button"
                      onClick={() => remove(index)}
                    >
                      <IoRemove size={26} color="red" />
                    </Button>}
                   
                  </div> */}
              </React.Fragment>
            </Grid>
          </DialogContent>
          <DialogActions style={{ padding: "12px 24px" }}>
            <Button
              onClick={handleAssetsEditModalClose}
              variant="contained"
              color="secondary"
              size="small"
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              color="primary"
              size="small"
              type="submit"
            >
              Save
            </Button>
          </DialogActions>
        </form>
      </Dialog>

      <Backdrop className={classes.backdrop} open={loader}>
        <CircularProgress color="inherit" />
      </Backdrop>
    </>
  );
};

export default AdminAssetManagent;
